import React, { useState, useEffect } from "react";
import ConfirmDialog from "../../../components/actionDialogs/confirmDialog";
import CustomTable from "../../../components/table/table";
import "./view.css";
import {
  get_advisorsList_list,
  admin_advisors_delete,
  get_mou_list,
  admin_mou_delete,
  get_membership_list,
  get_membership_details,
  admin_membership_delete,
  get_faq_list,
  admin_faq_delete,
} from "../admin.api";
import Loader from "../../../components/loader/loader";
import Snackbar from "../../../components/snackbar/snackbar";
import ReactHtmlParser from "react-html-parser";
import jwtDecode from "jwt-decode";

export default function View(props) {
  const [data, setData] = useState([]);
  const [view, setView] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  let adminType = Number(jwtDecode(props.state.payload).user_type);

  const onSearch = () => {
    //
  };

  const handleFaqList = async () => {
    setIsActive(true);
    try {
      const res = await get_faq_list(adminType);
      const tdata = Array.isArray(res?.faqs)
        ? res.faqs.map((item, index) => ({
            ...item,
            slno: index + 1,
          }))
        : [];
      setData(tdata);
    } catch (error) {
      setData([]);
    } finally {
      setIsActive(false);
    }
  };

  useEffect(() => {
    handleFaqList();
  }, []);

  useEffect(() => {
    return () => {
      setData([]);
    };
  }, []);

  const handleEdit = (row) => {
    let path = `/faq-edit/${row.id}`;
    props.history.push(path);
  };

  const handleAddNew = () => {
    let path = "/faq-add";
    props.history.push(path);
  };

  const handleView = (data) => {
    let path = `/faq-view/${data.id}`;
    props.history.push(path);
  };

  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };

  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_faq_delete(data.id)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleFaqList();
    }
  };

  const handleCancelDelete = () => {
    setOpenAction(false);
  };

  return (
    <div>
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        <h6>
          <b>FAQ</b>
        </h6>
        <hr />
        {/* --------------admin----- */}
        {adminType === 1 && (
          <>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={(e) => handleAddNew(e)}
            >
              Add New
            </button>
            <CustomTable
              {...props}
              columns={[
                {
                  title: "Question",
                  field: "question",
                  render: (rowData) => (
                    <div>{ReactHtmlParser(rowData.question)}</div>
                  ),
                },

                {
                  title: "Answer",
                  field: "answer",
                  render: (rowData) => (
                    <div>{ReactHtmlParser(rowData.answer)}</div>
                  ),
                },
                { title: "Status", field: "status", type: "faqStatus" },
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "edit", handleClick: handleEdit },
              ]}
            />
          </>
        )}
        {/* ----------------- */}
        {/* --------------admin----- */}
        {adminType === 2 && (
          <>
            <CustomTable
              {...props}
              columns={[
                {
                  title: "Question",
                  field: "question",
                  render: (rowData) => (
                    <div>{ReactHtmlParser(rowData.question)}</div>
                  ),
                },

                {
                  title: "Answer",
                  field: "answer",
                  render: (rowData) => (
                    <div>{ReactHtmlParser(rowData.answer)}</div>
                  ),
                },
                { title: "Status", field: "status", type: "faqStatus2" },
              ]}
              data={data}
              actions={[
                { type: "view", handleClick: handleView },
                { type: "delete", handleClick: handleDelete },
              ]}
            />
          </>
        )}
        {adminType === 23 && (
          <>
            <CustomTable
              {...props}
              columns={[
                {
                  title: "Question",
                  field: "question",
                  render: (rowData) => (
                    <div>{ReactHtmlParser(rowData.question)}</div>
                  ),
                },

                {
                  title: "Answer",
                  field: "answer",
                  render: (rowData) => (
                    <div>{ReactHtmlParser(rowData.answer)}</div>
                  ),
                },
                { title: "Status", field: "status", type: "faqStatus2" },
              ]}
              data={data}
              actions={[{ type: "view", handleClick: handleView }]}
            />
          </>
        )}
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete FAQ ?"
          data={activeData}
          message="Are you sure to delete this FAQ?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
